<template>
  <!-- 分区计量-工作台 -->
  <div>
    <div class="page-header-index-wide">
      <a-row :gutter="24">
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-card>
              <a-form layout="horizontal">
                <a-row :gutter="48">
                  <a-col :md="12" :sm="12">
                    <a-col :md="24" :sm="24">
                      <a-form-item label="片区" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <div style="display: flex; align-items: center;">
                          <a-tree-select @change="changeTreeSelect" :tree-data="zoneTreeData" v-model="zoneId"
                            treeNodeFilterProp="title" style="width: 300px"
                            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                            :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search></a-tree-select>

                          <div style="margin-left: 20px; white-space: nowrap; margin-right: 10px;">平行大用户:</div>
                          <a-select style="width: 300px;" v-model="parallelBigUserIds"
                            :disabled="!zoneId || queryField === 'night_flow' || queryField === 'flow_day'"
                            placeholder="请选择平行大用户" allow-clear option-filter-prop="children" show-search>
                            <a-select-option v-for="item in parallelUserList" :key="item.id" :value="item.id">
                              {{ item.userName }}
                            </a-select-option>
                          </a-select>
                        </div>
                      </a-form-item>
                    </a-col>

                    <a-col :md="24" :sm="0">
                      <a-form-item label="指标" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="queryField" button-style="solid" @change="radioChange">
                          <a-radio-button value="flow_rate">瞬时流量</a-radio-button>
                          <a-radio-button value="night_flow">夜间最小流量</a-radio-button>
                          <a-radio-button value="clean_flow">累积量</a-radio-button>
                          <a-radio-button value="flow_day">日高峰流量</a-radio-button>
                          <a-radio-button value="net_flow">净流量</a-radio-button>
                          <!-- <a-radio-button value="flow_jll">日净流量</a-radio-button> -->
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :md="24" :sm="24">
                      <a-form-item label="步长" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="stepLength" button-style="solid" :disabled="isStep">
                          <a-radio-button :disabled="StepDisableValue > 5" :value="5">5分钟</a-radio-button>
                          <a-radio-button :disabled="StepDisableValue > 15" :value="15">15分钟</a-radio-button>
                          <a-radio-button :disabled="StepDisableValue > 30" :value="30">30分钟</a-radio-button>
                          <a-radio-button :disabled="StepDisableValue > 60" :value="60">1小时</a-radio-button>
                          <a-radio-button :disabled="StepDisableValue > 1440" :value="1440">一天</a-radio-button>
                          <a-radio-button :disabled="StepDisableValue > 43200" :value="43200">一月</a-radio-button>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :md="24" :sm="24">
                      <a-form-item label="时长" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group button-style="solid" @change="changeTime" v-model="timeModel">
                          <a-radio-button value="今天">今天</a-radio-button>
                          <a-radio-button value="昨天">昨天</a-radio-button>
                          <a-radio-button value="近7天">近7天</a-radio-button>
                          <a-radio-button value="近15天">近15天</a-radio-button>
                          <a-radio-button value="近30天">近30天</a-radio-button>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :md="24" :sm="24">
                      <a-form-item label="时间选择" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-month-picker
                          v-if="isCleanFlowMonthStep"
                          style="margin-left: 20px; width: 195px"
                          format="YYYY-MM"
                          :allow-clear="false"
                          :value="monthQueryValue"
                          :disabled-date="disabledMonthDate"
                          placeholder="请选择查询月份"
                          @change="onMonthChange"
                        />
                        <a-range-picker
                          v-else
                          style="margin-left: 20px; width: 195px"
                          @change="onChange"
                          format="YYYY-MM-DD 00:00:00"
                          :mode="['date', 'date']"
                          :allow-clear="false"
                          :value="value"
                          :placeholder="['查询开始时间', '查询结束时间']"
                        />
                        <a-button
                          type="primary"
                          style="margin-left: 20px; border-radius: 4px"
                          @click="queryInit"
                          :loading="statisticsChartLoading"
                          :disabled="statisticsChartLoading"
                        >查询</a-button>
                      </a-form-item>
                    </a-col>
                    <a-col :md="24" :sm="24">
                      <a-form-item label="对比查询" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-month-picker
                          v-if="isCleanFlowMonthStep"
                          style="margin-left: 20px; width: 200px"
                          format="YYYY-MM"
                          :allow-clear="false"
                          :value="monthContrastValue"
                          :disabled-date="disabledMonthDate"
                          placeholder="请选择对比月份"
                          @change="onContrastMonthChange"
                        />
                        <a-range-picker
                          v-else
                          style="margin-left: 20px; width: 200px"
                          @change="contrastOnChange"
                          format="YYYY-MM-DD 00:00:00"
                          :mode="['date', 'date']"
                          :allow-clear="false"
                          :value="contrastValue"
                          :placeholder="['对比开始时间', '对比结束时间']"
                          allowClear
                        />
                        <a-button
                          type="primary"
                          style="margin-left: 20px; border-radius: 4px"
                          @click="contrastHandle"
                          :loading="statisticsChartLoading"
                          :disabled="statisticsChartLoading"
                        >对比</a-button>
                        <a-button v-show="cleanFlowShow" type="primary" style="margin-left: 8px"
                          @click="cleanExportHandle()" :loading="cleanExportLoading">导出</a-button>
                        <a-button v-show="isStep" type="primary" style="margin-left: 8px" @click="exportHandle()"
                          :loading="exportLoading">导出</a-button>
                        <a-button v-show="isStep" type="primary" style="margin-left: 8px" @click="exportAllHandle()"
                          :loading="exportAllLoading">导出全部</a-button>
                      </a-form-item>
                    </a-col>
                  </a-col>
                </a-row>
              </a-form>
            </a-card>
          </a-col>

          <div class="statistics-cards">
            <div class="stat-card" style="margin-right: 10px">
              <div class="stat-title">用户数量</div>
              <div class="stat-value">{{ usernum }}户</div>
            </div>
            <div class="stat-card">
              <div class="stat-title">DN75以上管网长度</div>
              <div class="stat-value">{{ gwcd }}m</div>
            </div>
          </div>

          <StatisticsChart ref="statisticsChart" v-if="queryField !== 'flow_jll'" :chartType="chartType"
            :zonewaterMeter="zonewaterMeter" :showZoneRule="showZoneRule" :queryField="queryField" :zoneName="zoneName"
            @chart-loading="statisticsChartLoading = $event">
          </StatisticsChart>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
// 阿拉伯数字转换成大写汉字
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import StatisticsChart from './StatisticsChart'
import historyChart from './historyChart'
import moment from 'moment'

function numberParseChina (money) {
  // 汉字的数字
  // eslint-disable-next-line no-array-constructor
  var cnNums = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十')
  return cnNums[money]
}

function GetDateStr (AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 获取当前月份的日期
  var d = dd.getDate()
  if (m < 10) m = '0' + m
  if (d < 10) d = '0' + d
  return y + '-' + m + '-' + d + ' 00:00:00'
}

export default {
  name: 'RemoteWaterMeterList',
  components: {
    StatisticsChart,
    historyChart,
    moment,
  },
  // cleanExportHandle

  data () {
    return {
      jllTime: undefined,
      cleanExportLoading: false,
      cleanFlowShow: false,
      StepDisableValue: '',
      isStep: false,
      exportLoading: false,
      exportAllLoading: false,
      isContrast: false,
      exportDataUrl: 'pipe-network/report/chart/night-traffic/export',
      cleanExportDataUrl: 'pipe-network/report/chart/export',
      stepLength: '60',
      stepLengths: 5,
      queryField: 'flow_rate',
      value: [GetDateStr(0), GetDateStr(1)],
      contrastValue: [],
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      zoneTreeData: [], // 分区数据选项
      zoneId: undefined,
      zoneName: '',
      dateFormat: 'YYYY-MM-DD 00:00:00',
      chartType: 'line', //图表类型
      gwcd: 0,
      usernum: '',
      showZoneRule: {},
      zonewaterMeter: {},
      waterMeterId: '',
      timeModel: '今天',
      statisticsChartLoading: false, // 图表接口等待态（由子组件透传）
      monthQueryValue: null, // 累积量月步长时的单月选择值
      monthContrastValue: null, // 累积量月步长时的对比单月选择值
      treeDefaultExpandedKeys: [], //默认展开的树节点
      parallelBigUserIds: undefined, // 平行大用户id
      parallelUserList: [], // 平行大用户下拉框数据
    }
  },
  computed: {
    // 累积量 + 一月步长时切换为“年月”选择
    isCleanFlowMonthStep () {
      return this.queryField === 'clean_flow' && Number(this.stepLength) === 43200
    }
  },

  created () {
    const type = this.$route.query.type
    const zoneId = this.$route.query.zoneId
    const waterMeterId = this.$route.query.waterMeterId
    const startTime = this.$route.query.startTime
    const restoreStateRaw = this.$route.query.restoreState

    this.zoneId = zoneId
    console.log('this.$route.query', this.$route.query)
    if (type != undefined) {
      this.queryField = type

      if (type == 'night_flow') {
        this.chartType = 'bar'
        this.StepDisableValue = 99999

      } else if (type == 'net_flow') {
        this.StepDisableValue = 60
        this.stepLength = 1440
        this.chartType = 'bar'
        this.timeModel = '近7天'
        this.value = [GetDateStr(-7), GetDateStr(0)]
      } else {
        this.stepLength = 60
      }
      this.getStepSize(type)
      if (waterMeterId != undefined) {
        this.waterMeterId = waterMeterId
      }

      const url = new URL(window.location.href)
      const baseUrl = url.origin + url.pathname // 获取基础URL（不包含查询参数）
      window.history.replaceState({}, '', baseUrl) // 替换当前历史记录条目
    }
    if (startTime) {
      var nextDate = new Date(startTime) // 复制当前日期对象
      nextDate.setDate(nextDate.getDate() + 1) // 在当前日期基础上加一天
      const year = nextDate.getFullYear()
      const month = (nextDate.getMonth() + 1).toString().padStart(2, '0')
      const day = nextDate.getDate().toString().padStart(2, '0')

      this.value = [startTime + ' 00:00:00', `${year}-${month}-${day}` + ' 00:00:00']
    }
    if (restoreStateRaw) {
      try {
        const restoreState = JSON.parse(decodeURIComponent(restoreStateRaw))
        if (restoreState.zoneId !== undefined && restoreState.zoneId !== null && restoreState.zoneId !== '') {
          this.zoneId = restoreState.zoneId
        }
        if (restoreState.queryField) {
          this.queryField = restoreState.queryField
          if (restoreState.queryField === 'night_flow' || restoreState.queryField === 'flow_day') {
            this.chartType = 'bar'
            this.StepDisableValue = 99999
          } else if (restoreState.queryField === 'net_flow') {
            this.StepDisableValue = 60
            this.chartType = 'bar'
          }
          this.getStepSize(restoreState.queryField)
        }
        if (restoreState.stepLength !== undefined && restoreState.stepLength !== null && restoreState.stepLength !== '') {
          this.stepLength = restoreState.stepLength
        }
        if (restoreState.parallelBigUserIds !== undefined) {
          this.parallelBigUserIds = restoreState.parallelBigUserIds
        }
        if (restoreState.queryBeginTime && restoreState.queryEndTime) {
          let displayEndTime = restoreState.queryEndTime
          // clean_flow 查询参数中的结束时间是“实际查询口径”（会 +1 天），回填到页面时需还原为用户选择口径
          if (restoreState.queryField === 'clean_flow') {
            displayEndTime = moment(restoreState.queryEndTime).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
          }
          this.value = [restoreState.queryBeginTime, displayEndTime]
        }

        const url = new URL(window.location.href)
        const baseUrl = url.origin + url.pathname
        window.history.replaceState({}, '', baseUrl)
      } catch (error) {
        console.warn('restoreState parse error:', error)
      }
    }
    this.syncTimeModelByRange()
    this.getZoneData()
    this.setSystemName()
    this.jllTime = this.getCurrentData()
  },
  methods: {
    normalizeMonthRange (dateString) {
      if (!Array.isArray(dateString) || dateString.length !== 2 || !dateString[0] || !dateString[1]) {
        return dateString
      }
      const start = moment(`${dateString[0]}-01`).startOf('month').format('YYYY-MM-DD 00:00:00')
      const end = moment(`${dateString[1]}-01`).endOf('month').format('YYYY-MM-DD 00:00:00')
      return [start, end]
    },
    syncTimeModelByRange () {
      if (!Array.isArray(this.value) || this.value.length !== 2 || !this.value[0] || !this.value[1]) {
        this.timeModel = null
        return
      }
      const start = moment(this.value[0]).startOf('day')
      const end = moment(this.value[1]).startOf('day')
      if (!start.isValid() || !end.isValid()) {
        this.timeModel = null
        return
      }
      const diffDays = end.diff(start, 'days')
      const endIsTomorrow = end.isSame(moment().add(1, 'day').startOf('day'))
      if (diffDays === 1 && start.isSame(moment().startOf('day')) && endIsTomorrow) {
        this.timeModel = '今天'
      } else if (diffDays === 1 && start.isSame(moment().subtract(1, 'day').startOf('day')) && end.isSame(moment().startOf('day'))) {
        this.timeModel = '昨天'
      } else if (diffDays === 7 && start.isSame(moment().subtract(6, 'day').startOf('day')) && endIsTomorrow) {
        this.timeModel = '近7天'
      } else if (diffDays === 15 && start.isSame(moment().subtract(14, 'day').startOf('day')) && endIsTomorrow) {
        this.timeModel = '近15天'
      } else if (diffDays === 30 && start.isSame(moment().subtract(29, 'day').startOf('day')) && endIsTomorrow) {
        this.timeModel = '近30天'
      } else {
        this.timeModel = null
      }
    },
    // 单月选择（用于累积量 + 一月步长）
    onMonthChange (date, dateString) {
      this.monthQueryValue = date
      if (!dateString) {
        return
      }
      const start = moment(`${dateString}-01`).startOf('month').format('YYYY-MM-DD 00:00:00')
      const end = moment(`${dateString}-01`).endOf('month').format('YYYY-MM-DD 00:00:00')
      this.value = [start, end]
    },
    // 对比单月选择（用于累积量 + 一月步长）
    onContrastMonthChange (date, dateString) {
      this.monthContrastValue = date
      if (!dateString) {
        return
      }
      const start = moment(`${dateString}-01`).startOf('month').format('YYYY-MM-DD 00:00:00')
      const end = moment(`${dateString}-01`).endOf('month').format('YYYY-MM-DD 00:00:00')
      this.contrastValue = [start, end]
    },
    // 仅允许选择“上月及以前”的月份（禁用本月和未来）
    disabledMonthDate (current) {
      const thisMonthStart = moment().startOf('month')
      return current && current >= thisMonthStart
    },
    // 查询时实际使用的结束时间（累积量结束时间在原有基础上 +1 天）
    getQueryEndTime (endTime) {
      if (this.queryField === 'clean_flow' && endTime) {
        // 这里不再用 this.dateFormat（固定为 00:00:00），避免小时信息被格式化丢失
        let m = moment(endTime).add(1, 'day')
        // 直接按完整时间格式返回给后端
        return m.format('YYYY-MM-DD HH:mm:ss')
      }
      return endTime
    },
    //获取分区计量规则
    getcalculaterule () {
      if (!this.zoneId) {
        return
      }

      this.$http
        .get('zone-metering/calculate-rule?zoneId=' + this.zoneId)
        .then(({ data }) => {
          if (!data.list || !data.list.length) {
            return
          }

          const rule = data.list[0]
          this.zoneName = rule.zoneName || ''

          if (!rule.value) {
            return
          }
        })
        .catch((error) => {
          this.$message.error('获取计算规则失败')
        })
    },
    //获取片区下面的水表

    getwaterMeter () {
      this.$http.get('/zone-metering/zone-metering/get/zone/waterMeter/' + this.zoneId).then(({ data }) => {
        this.zonewaterMeter = data
        if (this.waterMeterId) {
          // 新对象，用于存储结果
          const newObject = {}
          // 遍历原始对象
          for (const key in data) {
            // 如果键不是给定的键
            if (key !== this.waterMeterId) {
              // 将原始对象中的值作为新对象的键，并设置其值为 false
              newObject[key] = false
            }
          }
          // 添加额外的键和值
          newObject['片区流量'] = false

          this.showZoneRule = newObject
        } else {
          this.showZoneRule = undefined
        }

        this.getcalculaterule()
      })
    },

    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}分区计量系统`)
    },
    moment,

    getCurrentData () {
      return new Date(parseInt(+new Date() - 3600 * 1000 * 24)).toLocaleDateString().replace(/[/]+/g, '-')
    },


    disabledDate (current) {
      return current && current > moment().subtract(1, 'days')
    },
    // 累积量导出

    cleanExportHandle () {
      this.cleanExportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          queryBeginTime: this.value[0],
          queryEndTime: this.getQueryEndTime(this.value[1]),
          queryField: this.queryField,
          stepLength: this.stepLength,
          zoneId: this.zoneId,
          isMoment: true,
          isType: true,
        },
        headers: {
          Authorization: token,
        },
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.cleanExportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.cleanExportLoading = false
        })
        .catch(() => {
          this.cleanExportLoading = false
        })
    },

    radioChange (e) {
      const val = e.target.value
      //夜间最小流量和日高峰流量：默认展示柱状图
      if (val == 'night_flow' || val == 'flow_day') {
        this.parallelBigUserIds = undefined
        this.StepDisableValue = 99999
        this.chartType = 'bar'
      } else if (val == 'net_flow') {
        this.StepDisableValue = 60
        this.stepLength = 1440
        this.chartType = 'bar'
      } else {
        this.stepLength = this.stepLengths
        this.StepDisableValue = 0
        this.stepLength = 60
        this.chartType = 'line'
      }
      // 净流量单独显示
      if (val !== '') {
        this.getZoneData()
      } else {
        if (val === 'night_flow' || val === 'flow_day') {
          this.stepLength = '1440'
          this.isStep = true
          this.cleanFlowShow = false
        } else if (val === 'clean_flow') {
          this.isStep = false
          this.cleanFlowShow = true
        } else {
          this.isStep = false
          this.cleanFlowShow = false
        }
      }
    },
    // 导出

    exportHandle () {
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          queryBeginTime: this.value[0],
          queryEndTime: this.getQueryEndTime(this.value[1]),
          queryField: this.queryField,
          stepLength: this.stepLength,
          // zoneId: this.zoneId
          zoneId: this.zoneId,
          isMoment: !(this.queryField === 'night_flow' || this.queryField === 'flow_day'),
          isType: !(this.queryField === 'night_flow' || this.queryField === 'flow_day'),
        },
        headers: {
          Authorization: token,
        },
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xls'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // 导出全部

    exportAllHandle () { },
    // 对比按钮

    contrastHandle () {
      this.isContrast = true
      if (!this.contrastValue.length) {
        this.$message.error('请选择对比时间')
      } else {
        const needSpanCheck = !(this.queryField === 'clean_flow' && Number(this.stepLength) === 43200)
        if (
          needSpanCheck &&
          new Date(this.value[1]) - new Date(this.value[0]) !=
          new Date(this.contrastValue[1]) - new Date(this.contrastValue[0])
        ) {
          this.$message.error('对比时间与查询时间的跨度天数请保存一致！')
          return
        }
        const params = {
          queryBeginTime: this.value[0],
          queryEndTime: this.getQueryEndTime(this.value[1]),
          contrastBeginTime: this.contrastValue[0],
          contrastEndTime: this.getQueryEndTime(this.contrastValue[1]),
          queryField: this.queryField,
          stepLength: this.stepLength,
          zoneId: this.zoneId,
          isMoment: !(this.queryField === 'night_flow' || this.queryField === 'flow_day'),
          isType: !(this.queryField === 'night_flow' || this.queryField === 'flow_day'),
        }
        this.$refs.statisticsChart.getList(params)
      }
    },

    changeTime (e) {
      const time = e.target.value
      if (time === '今天') {
        this.value = [GetDateStr(0), GetDateStr(1)]
      } else if (time === '昨天') {
        this.value = [GetDateStr(-1), GetDateStr(0)]
      } else if (time === '近7天') {
        this.value = [GetDateStr(-6), GetDateStr(1)]
      } else if (time === '近15天') {
        this.value = [GetDateStr(-14), GetDateStr(1)]
      } else if (time === '近30天') {
        this.value = [GetDateStr(-29), GetDateStr(1)]
      }
      this.syncTimeModelByRange()
    },

    queryInit () {
      this.showZoneRule = {}
      this.waterMeterId = ''
      this.init()
    },

    init () {
      if (this.queryField !== 'flow_jll') {
        this.isContrast = false
        if (this.zoneId === undefined) {
          this.$message.error('请选择至少一个查询片区')
        } else {
          this.getwaterMeter()
          this.lineNumber()
          this.getusercount()

          const statisticsParams = {
            parallelBigUserIds: this.parallelBigUserIds,
            queryBeginTime: this.value[0],
            queryEndTime: this.getQueryEndTime(this.value[1]),
            queryField: this.queryField,
            stepLength: this.stepLength,
            zoneId: this.zoneId,
            isMoment: !(this.queryField === 'night_flow' || this.queryField === 'flow_day'),
            isType: !(this.queryField === 'night_flow' || this.queryField === 'flow_day'),
          }
          this.$refs.statisticsChart.getList(statisticsParams)
        }
      }
    },

    getStepSize (type) {
      if (!this.zoneId) {
        return
      }
      this.$http.get('zone-metering/calculate-rule/stepSize/' + this.zoneId).then(({ data }) => {
        // this.StepDisableValue = data

        if (type != 'net_flow') {
          this.stepLength = data
        }
        this.stepLengths = data
      })
    },

    getZoneData () {

      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)
        if (data != null && this.zoneId == undefined) {
          this.zoneId = data[0].zoneId
          if (this.zoneId) {
            this.lineNumber()
            this.getusercount()
            this.getwaterMeter()
            this.getStepSize()
            this.getParallelUserList()
          }
          // this.stepLength = data[0].stepLength
          localStorage.setItem('zoneId', this.zoneId)
          localStorage.setItem('zoneName', data[0].zoneName)
        }
        this.init()
      })
    },
    //获取片区下符合管径长度的数量(DN75)

    lineNumber () {
      this.$http.get('zone-metering/zone-metering/get/line/number/75/' + this.zoneId).then(({ data }) => {
        this.gwcd = data
      })
    },
    //获取片区下用户数量

    getusercount () {
      this.$http.get('pipe-network/zone-metering/get/zone/waterMeter/user/count/' + this.zoneId).then(({ data }) => {
        this.usernum = data
      })
    },

    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          if (item.zoneName !== '一级分区') {
            item.zoneName = numberParseChina(item.level) + '级分区——' + item.zoneName
          }
          item.children = this.chuli(item.children)
          if (item.zoneName.indexOf('一级分区') > -1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },

    onChange (date, dateString) {
      this.value = this.isCleanFlowMonthStep ? this.normalizeMonthRange(dateString) : dateString
      this.syncTimeModelByRange()
      console.log(dateString)
    },

    contrastOnChange (date, dateString) {
      this.contrastValue = this.isCleanFlowMonthStep ? this.normalizeMonthRange(dateString) : dateString
    },

    changeTreeSelect (extra) {
      if (this.zoneId) {
        this.getParallelUserList()
      }
      this.parallelUserIds = undefined
      if (this.queryField == 'clean_flow' || this.queryField == 'flow_rate') {
        this.getStepSize()
      }
    },
    // 获取平行大用户列表
    getParallelUserList () {
      this.parallelUserList = []
      if (!this.zoneId) {
        return
      }
      this.$http.get('/zone-metering/parallel/user/list/by-zone', {
        params: {
          zoneId: this.zoneId
        }
      }).then(({ data }) => {
        this.parallelUserList = data
      })
    },
  },
  watch: {
    // 切换到“累积量 + 一月步长”时，默认选择上月
    isCleanFlowMonthStep (newVal) {
      if (newVal) {
        const lastMonth = moment().subtract(1, 'month').startOf('month')
        this.monthQueryValue = lastMonth
        this.monthContrastValue = lastMonth
        this.value = [
          lastMonth.clone().startOf('month').format('YYYY-MM-DD 00:00:00'),
          lastMonth.clone().endOf('month').format('YYYY-MM-DD 00:00:00')
        ]
        this.contrastValue = [
          lastMonth.clone().startOf('month').format('YYYY-MM-DD 00:00:00'),
          lastMonth.clone().endOf('month').format('YYYY-MM-DD 00:00:00')
        ]
      } else {
        this.monthQueryValue = null
        this.monthContrastValue = null
      }
    }
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 10px;
}

.date-tips-text {
  font-size: 12px;
  color: #f5222d;
  margin-left: 10px;
}

.statistics-cards {
  top: 25px;
  position: absolute;
  right: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .stat-card {
    width: 160px;
    padding: 12px 15px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;

    .stat-title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    .stat-value {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
